import { Injectable } from '@angular/core';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Observable, throwError } from 'rxjs';
import { catchError } from 'rxjs/operators';
import { environment } from '../../environments/environment';

@Injectable({
  providedIn: 'root'
})
export class VinsBuquesService {

  token: string;
  httpOptions;
  httpOptionsABM;
  constructor(private http: HttpClient) {
    this.updateToken();
   }

  URL_InspeccionTotal = `${environment.URL_InspeccionTotal}`;

  handleError(error) {
    let errorMessage = '';
    window.alert(error.error);
    if (error.error instanceof ErrorEvent) {
      // Get client-side error
      errorMessage = error.error.message;
    } else {
      // Get server-side error
      errorMessage = `Error Code: ${error.status}\nMessage: ${error.message}`;
    }
    // window.alert(errorMessage);
    return throwError(errorMessage);
  }

  handleErrorInf(error) {
    let errorMessage = '';
    if (error.error instanceof ErrorEvent) {
      // Get client-side error
      errorMessage = error.error.message;
    } else {
      // Get server-side error
      errorMessage = `Error Code: ${error.status}\nMessage: ${error.error.errors[0].message}`;
    }
    window.alert(errorMessage);
    return throwError(errorMessage);
  };

  updateToken(){
    this.token = localStorage.getItem('token');
    this.httpOptions = {
      headers: new HttpHeaders({
        'Content-Type': 'application/json; charset=UTF-8','Authorization': 'Bearer ' + this.token
      })
    };
    this.httpOptionsABM = {
      headers: new HttpHeaders({
        'Content-Type': 'application/json; charset=UTF-8','Authorization': 'Bearer ' + this.token
      }),
      observe: 'response'
    };
  }

  searchVins(): Array<any>{
    let vins = [
      {id: 1, VIN: 'D54354EFG53H353453', OrigenDestino: 'Terminal Zárate', NFactura: 3},
      {id: 2, VIN: 'D54354EFG53H353453', OrigenDestino: 'Terminal Zárate', NFactura: 3},
      {id: 3, VIN: 'D54354EFG53H353453', OrigenDestino: 'Terminal Zárate', NFactura: 3},
      {id: 4, VIN: 'D54354EFG53H353453', OrigenDestino: 'Terminal Zárate', NFactura: 3},
      {id: 5, VIN: 'D54354EFG53H353453', OrigenDestino: 'Terminal Zárate', NFactura: 3},
      {id: 6, VIN: 'D54354EFG53H353453', OrigenDestino: 'Terminal Zárate', NFactura: 3},
    ]
    return vins
  }

  getDatosVisita(idVisita:number, idProceso:number): Observable<any>{
    this.updateToken();
    return this.http.get(this.URL_InspeccionTotal + 'v1/visita/getDatosVisitas/' + idVisita + '/' + idProceso, this.httpOptions);
  }
  
  getBuquesVisitaAbiertas(idCliente:number): Observable<any>{
    this.updateToken();
    return this.http.get(this.URL_InspeccionTotal + 'v1/visita/getBuquesVisitaAbiertas/' + idCliente, this.httpOptions);
  }

  getBuquesVisitaTodos(idCliente:number): Observable<any>{
    this.updateToken();
    return this.http.get(this.URL_InspeccionTotal + 'v1/visita/getBuquesVisita/' + idCliente, this.httpOptions);
  }

  modificarVisitaDetalle(detail): Observable<any>{
    this.updateToken();
    return this.http.put(this.URL_InspeccionTotal + 'v1/visita-detalle/update' , detail, this.httpOptionsABM)
    .pipe(
      catchError(this.handleError)
    );
  }

  deleteVinsVisita(objDLT): Observable<any>{
    this.updateToken();
    return this.http.post<XMLHttpRequest>(this.URL_InspeccionTotal + 'v1/visita-detalle/deleteVins', objDLT, this.httpOptionsABM);
  }

  guardarVinsABuque(objGuardar) : Observable<any>{
    this.updateToken();
    return this.http.post<XMLHttpRequest>(this.URL_InspeccionTotal + 'v1/visita', objGuardar, this.httpOptionsABM)
    .pipe(
      catchError(this.handleError)
    );
  }
}
